<template>
  <div class="projects">
    <div class="techs">
      <button
        v-for="tech in techs"
        :key="tech"
        @click="filterTech(tech)"
        class="tech"
        :class="`tech--${tech}`"
      >
        {{ tech }}
      </button>
      <button @click="filterTech(all)" class="tech tech--all">all</button>
    </div>
    <div class="project__card">
      <ProjectCard
        v-for="project in displayedProjects"
        :key="project.id"
        :project="project"
      />
    </div>
  </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard.vue';
import { computed, ref } from '@vue/runtime-core';
export default {
  components: {
    ProjectCard,
  },
  props: ['projects'],
  setup(props) {
    const displayedProjects = ref(props.projects);
    const techsSet = new Set();
    const techs = computed(() => {
      props.projects.forEach((pr) => pr.tech.forEach((t) => techsSet.add(t)));
      return [...techsSet].sort();
    });
    const filterTech = (filterParam = 'all') => {
      if (filterParam === 'all') {
        displayedProjects.value = props.projects;
      } else {
        displayedProjects.value = props.projects.filter((el) =>
          el.tech.includes(filterParam)
        );
      }
    };

    return { techs, displayedProjects, filterTech };
  },
};
</script>

<style lang="scss">
.projects {
  .techs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    margin: 2rem;
    flex-wrap: wrap;
  }
  .tech {
    padding: 0.5rem 2rem;
    color: black;
    cursor: pointer;
    text-align: center;
    width: 10rem;

    // &:hover {
    //   transform: translateY(-3px);
    // }

    &:active {
      transform: translateY(-1px);
    }

    &:focus,
    &:focus-visible {
      color: #fff;
    }

    &--css {
      background-color: var(--bg-color-css);
      box-shadow: 0 0.5em var(--bg-color-css), 0 -0.5em var(--bg-color-css),
        0.5em 0 var(--bg-color-css), -0.5em 0 var(--bg-color-css);
    }
    &--scss {
      background-color: var(--bg-color-scss);
      box-shadow: 0 0.5em var(--bg-color-scss), 0 -0.5em var(--bg-color-scss),
        0.5em 0 var(--bg-color-scss), -0.5em 0 var(--bg-color-scss);
    }
    &--js {
      background-color: var(--bg-color-js);
      box-shadow: 0 0.5em var(--bg-color-js), 0 -0.5em var(--bg-color-js),
        0.5em 0 var(--bg-color-js), -0.5em 0 var(--bg-color-js);
    }
    &--vue {
      background-color: var(--bg-color-vue);
      box-shadow: 0 0.5em var(--bg-color-vue), 0 -0.5em var(--bg-color-vue),
        0.5em 0 var(--bg-color-vue), -0.5em 0 var(--bg-color-vue);
    }
    &--all {
      background-color: var(--bg-color-all);
      box-shadow: 0 0.5em var(--bg-color-all), 0 -0.5em var(--bg-color-all),
        0.5em 0 var(--bg-color-all), -0.5em 0 var(--bg-color-all);
    }
  }
  .project__card {
    padding: 4rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 25rem;
    gap: 4rem;

    @media (min-width: 55em) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 65em) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
